/* eslint-disable react-refresh/only-export-components --
   RouteFallback is an implementation detail of lazyRoute and is not rendered
   anywhere else; splitting it into a third file buys nothing. */
import { Suspense, type ReactNode } from "react";

import { Spinner } from "@/shared/ui";

function RouteFallback() {
  return (
    <div className="grid min-h-64 place-items-center" role="status" aria-live="polite">
      <Spinner />
      <span className="sr-only">Loading</span>
    </div>
  );
}

/** Wraps a lazily-imported route element in its suspense boundary. */
export function lazyRoute(element: ReactNode) {
  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
}
